import styled from '@emotion/styled'
export default styled('div')`
    display: flex;
    flex-direction: column;
`